/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SearchSheetRowSearchResultElementRepresentationFromJSON, SearchSheetRowSearchResultElementRepresentationToJSON, } from './';
export function SearchSheetRowSearchResultRepresentationFromJSON(json) {
    return SearchSheetRowSearchResultRepresentationFromJSONTyped(json, false);
}
export function SearchSheetRowSearchResultRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        path: json['path'],
        current: !exists(json, 'current')
            ? undefined
            : SearchSheetRowSearchResultElementRepresentationFromJSON(json['current']),
        children: json['children'].map(SearchSheetRowSearchResultElementRepresentationFromJSON),
    };
}
export function SearchSheetRowSearchResultRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        path: value.path,
        current: SearchSheetRowSearchResultElementRepresentationToJSON(value.current),
        children: value.children.map(SearchSheetRowSearchResultElementRepresentationToJSON),
    };
}
